import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrow = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 14,
	viewBox: "0 0 15 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	stroke: "#475467",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Arrow" }), /* @__PURE__ */ _jsx("path", {
		d: "M13.3333 7.00008H1.66663M1.66663 7.00008L7.49996 12.8334M1.66663 7.00008L7.49996 1.16675",
		stroke: "current",
		strokeWidth: 1.66667,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgArrow;
